import {faCalendarAlt} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {useMemo} from 'react';
import {getFreeIntervals} from '../../../../pages/Calendar/helper';
import BasicCheckbox from '../../../BasicCheckbox';
import CalendarInterval from '../CalendarInterval';
import './styles.css';

const CalendarDay = props => {
  const { duration, data, actions } = props;
  const { Dow, Name, Active, Ranges = [] } = data;

  const hasFreeIntervals = useMemo(
    () => !!getFreeIntervals(Ranges, duration).length,
    [Ranges]
  );

  const onChange = () => {
    actions.onDayStatusChange(Dow, !Active);
  };

  const onAddInterval = () => {
    actions.onAddInterval(Dow);
  };

  return (
    <div
      className={
        Active ? 'calendar-day' : 'calendar-day calendar-day--inactive'
      }
    >
      <div className="calendar-day__header">
        <h4 className="calendar-day__name">{Name}</h4>
        <BasicCheckbox
          value={Dow}
          singleRow
          checked={Active}
          title=""
          name="day"
          controlFunc={onChange}
          labelStyles={{
            fontFamily: 'Noto Sans, sans-serif',
            fontSize: '0.9286rem',
          }}
        />
      </div>
      <div className="calendar-day__content">
        {Active &&
          Ranges.map(period => (
            <CalendarInterval
              data={period}
              actions={{ onSelectTime: actions.onSelectTime }}
              key={period.ScheduleID}
            />
          ))}
        <div className="calendar-day__controls">
          {Active ? (
            hasFreeIntervals && (
              <button
                className="calendar-day__button calendar-day__button--small"
                onClick={onAddInterval}
                title="Add Time"
              >
                <span className="calendar-day__button-text">Add Time</span>

                <FontAwesomeIcon icon={faCalendarAlt} color="#f40" size="lg" />
              </button>
            )
          ) : (
            <button
              className="calendar-day__button"
              title="Add Time"
              onClick={onChange}
            >
              <FontAwesomeIcon icon={faCalendarAlt} color="inherit" size="2x" />
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalendarDay;
